// —————————————————
// UI
// —————————————————

// TYPES

export const RESIZE_SCREEN = 'RESIZE_SCREEN'
export const TOGGLE_MENU = 'TOGGLE_MENU'
export const TYPE_LOADED = 'TYPE_LOADED'
export const UPDATE_HEADER_COLOUR = 'UPDATE_HEADER_COLOUR'
export const TOGGLE_PAGE_IS_TRANSITIONING = 'TOGGLE_PAGE_IS_TRANSITIONING'

// ACTIONS

export const resizeScreen = (size) => ({
	type: RESIZE_SCREEN,
	screenSize: size
})

export const toggleMenu = (menu) => ({
	type: TOGGLE_MENU,
	menu: menu
})

export const typeLoad = (bool) => ({
	type: TYPE_LOADED,
	isLoaded: bool
})

export const updateHeaderColour = (colour) => ({
	type: UPDATE_HEADER_COLOUR,
	colour: colour
})

export const togglePageTransitioning = (bool) => ({
	type: TOGGLE_PAGE_IS_TRANSITIONING,
	isTransitioning: bool
})

// —————————————————
// PAGES
// —————————————————

// TYPES

export const SET_HEADER_COLOUR = 'SET_HEADER_COLOUR'
export const SET_HAS_SUB_MENU = 'SET_HAS_SUB_MENU'

// ACTIONS

export const setHeaderColour = (path, colour) => ({
	type: SET_HEADER_COLOUR,
	path,
	colour
})

export const setHasSubMenu = (path, bool) => ({
	type: SET_HAS_SUB_MENU,
	path,
	bool
})